import { Injectable } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidatorsService {
  constructor() {}

  /** Validator to make sure atleast once checkbox is clicked */
  requireCheckboxesToBeCheckedValidator(
    minRequired = 1,
    numOfSubscribedChannels = 0
  ): any {
    return function validate(formGroup: FormGroup) {
      if (numOfSubscribedChannels == 0) {
        return null;
      }

      // If subscribed channels exist ->
      let checked = 0;
      Object.keys(formGroup.controls).forEach((key) => {

        const control = formGroup.get(key);

        if (control?.value === true) {
          checked++;
        }
      });

      if (checked < minRequired) {
        return {
          requireCheckboxesToBeChecked: true,
        };
      }

      return null;
    };
  }

  allowDomainsValidator(domains: string[]): any {
    return function validate(formControl: FormControl) {
      if (domains.length == 0) {
        return null;
      }

      for (let domain of domains) {
        if (
          (formControl.value as string)
            ?.toLowerCase()
            ?.includes(domain?.toLowerCase())
        ) {
          return null;
        }
      }

      return {
        invalidDomain: true,
      };
    };
  }

   /** Validator to make sure only digits in an input (0–9) */
  allowOnlyDigits(event: Event): string {
    const input = event.target as HTMLInputElement;
    const value = input.value ?? '';

    // Keep only digits
    const filtered = value.replace(/\D/g, '');

    if (value !== filtered) {
      input.value = filtered;
    }

    return filtered;
  }
}
